<template>
  <div class="cd__image-list-item">
    <img :src="imageUrl" @click="openImage" />
    <v-dialog v-model="dialog" persistent max-width="100%">
      <div class="cd__image-list-item-big">
        <img :src="imageUrl" />
        <div class="cd__image-list-item-big-close">
          <v-btn icon @click="closeImage">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>

export default  {
  name: 'CdImageListItem',

  props: {
    imageUrl: {
      type: String
    },
  },
  data: () => ({
    dialog: false,
  }),

  computed: {
    
  },

  mounted() {
    
  },

  methods: {
    openImage() {
      this.dialog = true;
    },
    closeImage() {
      this.dialog = false;
    },
  },
}
</script>

<style scoped lang="scss">
.cd__image-list-item {
  cursor: pointer;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &-big {
    height: 90vh;
    background-color: #fff;
    position: relative;

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    &-close {
      background-color: #fff;
      border-radius: 100%;
      position: absolute;
      right: 24px;
      top: 24px;
      z-index: 3;
    }
  }
}
</style>
